"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = require("react");
var _propTypes = _interopRequireDefault(require("prop-types"));
var _reactRouterDom = require("react-router-dom");
var _components = require("@folio/stripes/components");
var _NoResultsMessage = _interopRequireDefault(require("../../NoResultsMessage"));
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
const TableBody = _ref => {
  let {
    data,
    error,
    fetchNextPage,
    filterPaneVisible,
    intlKey: passedIntlKey,
    intlNS: passedIntlNS,
    isError,
    isLoading,
    labelOverrides = {},
    match,
    mclProps: {
      formatter = {},
      ...mclProps
    } = {},
    onSort,
    path,
    resultColumns,
    rowNavigation = true,
    // Default navigation onRowClick
    toggleFilterPane,
    query
  } = _ref;
  const sortOrder = query.sort ?? '';
  const history = (0, _reactRouterDom.useHistory)();
  const location = (0, _reactRouterDom.useLocation)();
  const onNeedMoreData = (_askAmount, index) => {
    fetchNextPage({
      pageParam: index
    });
  };

  // Build the map of column definitions
  const columnMapping = Object.fromEntries(resultColumns.map(e => [e.propertyPath, e.label]));

  // Build the list of visible columns
  const visibleColumns = resultColumns.map(e => e.propertyPath);
  const getRowUrl = (0, _react.useCallback)(rowData => {
    const baseUrl = `${path}/${rowData?.id}`;
    return {
      url: `${baseUrl}${location?.search}`,
      path,
      baseUrl,
      location
    };
  }, [location, path]);
  const getEnhancedFormatter = (0, _react.useCallback)(() => {
    const enhancedFormatter = {};
    for (const [key, value] of Object.entries(formatter)) {
      enhancedFormatter[key] = item => value({
        ...item,
        defaultRowUrl: getRowUrl(item)
      });
    }
    return enhancedFormatter;
  }, [formatter, getRowUrl]);
  const getOnRowClick = (0, _react.useCallback)(() => {
    if (rowNavigation) {
      return (_e, rowData) => {
        history.push(getRowUrl(rowData).url);
      };
    }
    return null;
  }, [getRowUrl, history, rowNavigation]);
  const isSelected = (0, _react.useCallback)(_ref2 => {
    let {
      item
    } = _ref2;
    return item.id === match?.params?.id;
  }, [match?.params?.id]);
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_components.MultiColumnList, {
    autosize: true,
    columnMapping: columnMapping,
    contentData: data?.results,
    formatter: getEnhancedFormatter() // Pass enhanced formatter
    ,
    hasMargin: true,
    interactive: rowNavigation,
    isEmptyMessage: /*#__PURE__*/(0, _jsxRuntime.jsx)(_NoResultsMessage.default, {
      error,
      filterPaneIsVisible: filterPaneVisible,
      intlKey: passedIntlKey,
      intlNS: passedIntlNS,
      isError,
      isLoading,
      labelOverrides,
      searchTerm: query.query,
      toggleFilterPane
    }),
    isSelected: isSelected,
    onHeaderClick: onSort,
    onNeedMoreData: onNeedMoreData,
    onRowClick: getOnRowClick(),
    pagingType: "click",
    sortDirection: sortOrder.startsWith('-') ? 'descending' : 'ascending',
    sortOrder: sortOrder.replace(/^-/, '').replace(/,.*/, ''),
    totalCount: data.totalRecords,
    visibleColumns: visibleColumns,
    ...mclProps
  });
};
TableBody.propTypes = {
  data: _propTypes.default.shape({
    totalRecords: _propTypes.default.number,
    results: _propTypes.default.arrayOf(_propTypes.default.object)
  }),
  error: _propTypes.default.object,
  fetchNextPage: _propTypes.default.func,
  filterPaneVisible: _propTypes.default.bool,
  history: _propTypes.default.object,
  intlKey: _propTypes.default.string,
  intlNS: _propTypes.default.string,
  isError: _propTypes.default.bool,
  isLoading: _propTypes.default.bool,
  labelOverrides: _propTypes.default.object,
  location: _propTypes.default.object,
  match: _propTypes.default.object,
  mclProps: _propTypes.default.object,
  onSort: _propTypes.default.func,
  path: _propTypes.default.string.isRequired,
  query: _propTypes.default.object,
  resultColumns: _propTypes.default.arrayOf(_propTypes.default.object),
  rowNavigation: _propTypes.default.bool,
  toggleFilterPane: _propTypes.default.func
};
var _default = exports.default = TableBody;